/**
 * 商品企画マスタ画面　選定済一覧検索条件VOクラス
 */
export class KYMW1300GetSearchSelectedListModel {

  public dispMode: string = null;                                               // 表示モード(1：部門、2：ページ、3：バイヤー)
  public orderCode: string = null;                                              // 受注コード
  public mediumType: string = null;                                             // 媒体区分
  public sellAreaCode: string = null;                                           // 売り場コード
  public coopCode: string = null;                                               // 生協コード
  public classCode: string = null;                                              // 部門コード
  public middleClassCode: string = null;                                        // 中分類コード
  public smallClassCode: string = null;                                         // 小分類コード
  public pageNo: string = null;                                                 // ページ番号
  public buyerCode: string = null;                                              // バイヤーコード
  public nextGuideCheckFlg: string = null;                                      // 次回案内チェックフラグ(0：チェックしない、1：チェックする)
  public page: string = <string>'1';                                            // 表示開始ページ
  public sortItem: string = null;                                               // ソート項目名
  public sortOrder: string = null;                                              // 昇順降順区分(ASC, DESC)
  public orderNumQuotaCode: string = null;                                      // 注文コード割当コード
  public orderClientCode: string = null;                                        // 発注先コード
  public orderClientKanji: string = null;                                       // 発注先名称
  public payeeClientCode: string = null;                                        // 支払先コード
  public payeeClientKanji: string = null;                                       // 支払先名称
  public kikakuRenrakuStatus: string = null;                                    // 企画連絡ステータス

  public searchPCode: string = null;                                            // 検索対象Ｐコード

  // フォーカスフラグ(0：表示ボタン、1：前へボタン、2：次へボタン、3：表示モード・部門、4：次回案内一括設定、5：次回案内チェック)
  public focusFlg: string = null;

}
